function isSlideLinkNavigationSuppressed(target) {
  if (!target || target.nodeType !== Node.ELEMENT_NODE) return false;
  return Boolean(
    target.closest(
      "a[href], button, input, textarea, select, option, label, summary, [role='button'], [role='link'], [contenteditable='true']"
    )
  );
}

document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll(".slideshow.banner");
  sliders.forEach((slider) => {
    const dots = slider.closest(".hero-slideshow-items").querySelectorAll(".dots-navigation .dot");
    const slideshowComponent = slider.closest("slideshow-component");
    const isHeroSlideshow = slideshowComponent && slideshowComponent.hasAttribute("data-hero-slideshow");
    
    const allSlides = slider.closest(".hero-slideshow-items").querySelectorAll(".slideshow__slide");
    // Filter out cloned slides (only for hero slideshow)
    const slides = isHeroSlideshow 
      ? Array.from(allSlides).filter(slide => !slide.hasAttribute("data-cloned"))
      : Array.from(allSlides);

    if (!slider || slides.length === 0) return;

    if (dots.length > 0) {
      function getSlideWidth() {
        return slides[0].offsetWidth + parseInt(getComputedStyle(slides[0]).marginRight, 10);
      }

    slider.addEventListener("scroll", () => {
      const scrollLeft = slider.scrollLeft;
      const currentSlideWidth = getSlideWidth();
      let activeIndex = Math.round(scrollLeft / currentSlideWidth);
      
      if (isHeroSlideshow) {
        // Adjust for cloned last slide at the beginning (offset by 1)
        activeIndex = activeIndex - 1;
        
        // If we're at the cloned first slide at the end, show first dot as active
        if (activeIndex >= slides.length) {
          activeIndex = 0;
        }
        // If we're at the cloned last slide at the beginning, show last dot as active
        else if (activeIndex < 0) {
          activeIndex = slides.length - 1;
        }
      }

      dots.forEach((dot, index) => {
        dot.classList.toggle("active", index === activeIndex);
      });
    });

    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => {
        // For hero slideshow, offset by 1 to account for cloned last slide at beginning
        const offset = isHeroSlideshow ? 1 : 0;
        const targetScrollPosition = getSlideWidth() * (index + offset);
        slider.scrollTo({ left: targetScrollPosition, behavior: "smooth" });
      });
    });
  }
    slides.forEach((slide) => {
      const slideLink = slide.getAttribute("data-slide-link");
      if (!slideLink) return;

      let startX = 0;
      let startY = 0;
      let isDragging = false;

      slide.addEventListener("mousedown", (e) => {
        if (isSlideLinkNavigationSuppressed(e.target)) {
          startX = 0;
          startY = 0;
          return;
        }
        startX = e.clientX;
        startY = e.clientY;
        isDragging = false;
      });

      slide.addEventListener("mousemove", (e) => {
        if (startX !== 0 || startY !== 0) {
          const deltaX = Math.abs(e.clientX - startX);
          const deltaY = Math.abs(e.clientY - startY);
          if (deltaX > 10 || deltaY > 10) {
            isDragging = true;
          }
        }
      });

      slide.addEventListener("mouseup", (e) => {
        if (isSlideLinkNavigationSuppressed(e.target)) {
          startX = 0;
          startY = 0;
          isDragging = false;
          return;
        }

        const deltaX = Math.abs(e.clientX - startX);
        const deltaY = Math.abs(e.clientY - startY);
        if (!isDragging && deltaX < 10 && deltaY < 10) {
          window.location.href = slideLink;
        }

        startX = 0;
        startY = 0;
        isDragging = false;
      });
    });
  });
});
